import actions from './productActions';
import mutations from './productMutations';
import getters from './productGetters';

const state = {
  items: []
};

export default {
  namespaced: true,
  state,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./client/store/modules/product/index.js